const DateUtil = {
    FormatType1: 'yyyy年MM月',
    FormatType2: 'yyyy-M-d',
    FormatType3: 'yyyy-MM-dd',
    //月数加    (type 是月还是日 0月 1日)  
    getMonthBeforeFormatAndDay(dateStr ,num, format, type = 0, isEnd = 0) {
        var date = new Date(dateStr);
        let day = date.getDate();
        if(isEnd){
          day --;
          if(day < 1){
            num --;
            day = 31;
          }
        }


        if(type){
          date.setDate(date.getDate()+num);
          day = date.getDate();
        } else{
          date.setMonth(date.getMonth() + (num*1), 1); 
        }
        //读取日期自动会减一，所以要加一
        var mo = date.getMonth() + 1;
        //小月
        if (mo == 4 || mo == 6 || mo == 9 || mo == 11) {
            if (day > 30) {
                day = 30
            }
        }
        //2月
        else if (mo == 2) {
            if (DateUtil.isLeapYear(date.getFullYear())) {
                if (day > 29) {
                    day = 29
                }
            }
            if (day > 28) {
                day = 28
            }
        }
        //大月
        else {
            if (day > 31) {
                day = 31
            }
        }
    
        let retureValue = date.format('yyyy' + format + 'MM' + format + (day < 10? '0' + day: day));
    
        return retureValue;
    },
    getMonthBeforeFormatAndDay22(dateStr ,num, format, type = 0, isEnd = 0) {
      var date = new Date(dateStr);
      let day = date.getDate();
      if(isEnd){
        day --;
        if(day < 1){
          num --;
          day = 31;
        }
      }


      if(type){
        date.setDate(date.getDate()+num);
        day = date.getDate();
      } else{
        date.setMonth(date.getMonth() + (num*1), 1); 
      }
      //读取日期自动会减一，所以要加一
      var mo = date.getMonth() + 1;
      //小月
      if (mo == 4 || mo == 6 || mo == 9 || mo == 11) {
          if (day > 30) {
              day = 30
          }
      }
      //2月
      else if (mo == 2) {
          if (DateUtil.isLeapYear(date.getFullYear())) {
              if (day > 29) {
                  day = 29
              }
          }
          if (day > 28) {
              day = 28
          }
      }
      //大月
      else {
          if (day > 31) {
              day = 31
          }
      }
      let retureValue = date.format(format);
      return retureValue;
  },
    //当前时间年月
    GetYears(){
      return new Date().getFullYear()+'-'+(new Date().getMonth() >= 9? (new Date().getMonth()+1): '0'+(new Date().getMonth()+1));
    },
    //JS判断闰年代码 
    isLeapYear(Year) {
        if (((Year % 4) == 0) && ((Year % 100) != 0) || ((Year % 400) == 0)) {
            return (true);
        } else { return (false); }
    },
    //获取两个时间差的年份
    timeDifferenceYears(date1, date2) {
        let years = date1.getFullYear() - date2.getFullYear();
        if(date1.getMonth() < date2.getMonth()){
            years --;
        }else if(date1.getMonth() == date2.getMonth() && date1.getDate() < date2.getDate()){
            years --;
        }
        return years;
    },
    //格式化
    DateFormat: function(date, format){
        return date.format(format);
    },
    //获取两个日期的相差日期数(differ 相差天数：1、相差小时数：2、相差分钟数：3、相差秒数：4)
    GetDifferDate(startDate, endDate, differ) {

        //2)计算两个日期相差的毫秒数
        var msecNum = endDate.getTime() - startDate.getTime();
        //3)计算两个日期相差的天数
        var dayNum = Math.floor(msecNum /DateUtil.GetDifferScale(differ));
        return dayNum;
    }, 
    GetDifferScale(value) {
        var format;
        //获取转化比（天数跟毫秒数的比例）
        if (value == 1) {
            format = parseFloat(24 * 60 * 60 * 1000);
        }
            //获取转化比（小时数跟毫秒数的比例）
        else if (value == 2) {
            format = parseFloat(60 * 60 * 1000);
        }
            //获取转化比（分钟数跟毫秒数的比例）
        else if (value == 3) {
            format = parseFloat(60 * 1000);
        }
            //获取转化比（秒数跟毫秒数的比例）
        else if (value == 4) {
            format = parseFloat(1000);
        }
        return format;
    },
    dateDiff: function(d1, d2) { 
        var obj = {},
          M1 = d1.getMonth() + 1,
          D1 = d1.getDate(),
          M2 = d2.getMonth() + 1,
          D2 = d2.getDate();
        obj.Y = d2.getFullYear() - d1.getFullYear() + (M1 * 100 + D1 > M2 * 100 + D2 ? -1 : 0); //相差年份计算
        obj.M = (d2.getFullYear() - d1.getFullYear()) * 12 + M2 - M1 + (D1 > D2 ? -1 : 0);
        let ISD = false; 
        let month1 = [1, 3, 5, 7, 8, 10, 12];
        let month2 = [4, 6, 5, 9, 11]
        if (D2 > D1) { //结束时间的日期大于开始时间的日期，则相差天数为结束日期天数减开始日期天数加1
          obj.D = D2 - D1 + 1;
          if((month1.includes(M1) || month1.includes(M2)) && obj.D >= 31){
            ISD = true;
          } else if ((month2.includes(M1) || month2.includes(M2)) && obj.D >= 30) {  
              ISD = true; 
          } else if (M1 == 2 || M2 == 2) {
            if (d1.getFullYear() % 4 == 0 && d2.getFullYear() % 4 == 0) {
              if(obj.D >= 29){
                ISD = true;
             }
            } else if(obj.D >= 28){
                ISD = true; 
            }
          }
        } else if (D2 == D1) { //结束时间的日期等于开始时间的日期，则相差天数为1
          obj.D = 1;
        } else { //结束时间的日期小于于开始时间的日期，则相差天数为开始时间所在月的天数减去开始时间日期加上结束时间的日期
          
          if (month1.includes(M1)) {
            obj.D = 31 - D1 + D2 + 1; 
          } else if (month2.includes(M1)) {
            obj.D = 30 - D1 + D2 + 1; 
          } else if (M1 == 2) {
            if (d1.getFullYear() % 4 == 0 && d2.getFullYear() % 4 == 0) {
              obj.D = 29 - D1 + D2 + 1; 
            } else {
              obj.D = 28 - D1 + D2 + 1; 
            }
          }
          if((month1.includes(M1) || month1.includes(M2)) && obj.D >= 31){
            ISDFunc(31)
          } else if ((month2.includes(M1) || month2.includes(M2)) && obj.D >= 30) {  
            ISDFunc(30)
          } else if (M1 == 2 || M2 == 2) {
            if (d1.getFullYear() % 4 == 0 && d2.getFullYear() % 4 == 0) {
              if(obj.D >= 29){
                ISDFunc(29)
             }
            } else if(obj.D >= 28){
              ISDFunc(28)
            }
          }
        }

        obj.M = obj.M >= 12 ? obj.M % 12 : obj.M;

        if(ISD){
          ISDFunc()
        }
        function ISDFunc(num){
          obj.D = num ? obj.D - num : 0;
          obj.M = obj.M + 1;
          
          
          if(obj.M >= 12){
            obj.Y = obj.Y + 1;
            // obj.M = 0; 
            obj.M = obj.M >= 12 ? obj.M % 12 : obj.M;
          }
        }

        var text = "";
        if (obj.D > 0) {
          text = obj.D + "天";
        }
        if (obj.M > 0) {
          text = obj.M + "个月" + text;
          if (obj.Y > 0) {
            text = obj.Y + "年" + text;
          }
        }
        if (obj.M == 0) {
          if (obj.Y > 0) {
            if (text) {
              text = obj.Y + "年零" + text;
            } else {
              text = obj.Y + "年";
            }
          }
        }
        return text;
      }
}

//日期格式化
Date.prototype.format = function (format) {
    var o = {
        "M+": this.getMonth() + 1, // month
        "d+": this.getDate(), // day
        "h+": this.getHours(), // hour
        "m+": this.getMinutes(), // minute
        "s+": this.getSeconds(), // second
        "q+": Math.floor((this.getMonth() + 3) / 3), // quarter
        "S": this.getMilliseconds()
        // millisecond
    }

    if (/(y+)/.test(format))
        format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(format))
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    return format;
}

export default DateUtil;
